<template>
  <div class="login-page">
    <div class="login-card">
      <h2 style="text-align:center;margin-top:0;">HybridORS Admin</h2>
      <p style="text-align:center;color:#666;">Sports Health Admin System</p>
      <el-form ref="form" :model="form" :rules="rules" @submit.native.prevent="onSubmit">
        <el-form-item prop="username">
          <el-input v-model="form.username" prefix-icon="el-icon-user" placeholder="Username" />
        </el-form-item>
        <el-form-item prop="password">
          <el-input v-model="form.password" prefix-icon="el-icon-lock" type="password" placeholder="Password" show-password />
        </el-form-item>
        <el-button type="primary" style="width:100%;" :loading="loading" @click="onSubmit">Sign In</el-button>
      </el-form>
    </div>
  </div>
</template>

<script>
import request from '@/utils/request'
import { ensureDynamicRoutes } from '@/router'

export default {
  data() {
    return {
      loading: false,
      form: { username: 'admin', password: 'admin123' },
      rules: {
        username: [{ required: true, message: 'Please enter your username', trigger: 'blur' }],
        password: [{ required: true, message: 'Please enter your password', trigger: 'blur' }]
      }
    }
  },
  methods: {
    onSubmit() {
      this.$refs.form.validate(async valid => {
        if (!valid) return
        this.loading = true
        try {
          const res = await request.post('/auth/login', {
            username: this.form.username,
            password: this.form.password,
            clientType: 'admin'
          })
          this.$store.commit('SET_TOKEN', res.data.token)
          this.$store.commit('SET_NAME', res.data.user.name || res.data.user.username)
          await ensureDynamicRoutes()
          this.$router.replace('/dashboard')
        } finally {
          this.loading = false
        }
      })
    }
  }
}
</script>
